import React, {Component} from 'react';
import {sortAlphabetically} from "utils";
import LanguageHeader from './LanguageHeader';
import {Link} from 'react-router-dom';
import FontIcon from 'material-ui/FontIcon';
import RaisedButton from 'material-ui/RaisedButton';
import PackageAddDialog from './PackageAddDialog';
import {getObjectById} from "../../utils";
import {FlatButton} from "material-ui";
import {translate} from "react-i18next";

class PackagesList extends Component {

    buttonStyle = {
        textAlign: 'left',

    };

    labelStyle = {
        color: '#222'

    };

    style = {
        width: '250px',
        lineHeight: '50px',
        height: '50px',
        margin: 10,
        cursor: 'pointer',
    };


    truncateText(text, count) {
        if (text.length <= count) {
            return text;
        }
        return text.substring(0, count - 4) + '...'

    }

    renderPackage(pckg) {
        // back compatibility - try generate by slug (new way), or generate by id (old)
        // TODo: resolve in the future
        let url = '';
        if(pckg.slug){
            url = '/package/' + pckg.slug;
        } else {
            url = '/package/' + pckg.id;
        }

        return (
            <RaisedButton
                title={pckg.name}
                style={this.style}
                labelStyle={this.labelStyle}
                buttonStyle={this.buttonStyle}
                label={this.truncateText(pckg.name, 20)}
                icon={<FontIcon style={{color: '#888'}} className="material-icons">style</FontIcon>}
                containerElement={<Link to={url}/>}
                key={pckg.id}
            />
        )
    }

    render() {
        const packages = this.props.packages.slice().sort((a, b) => {
            return a.foreign_language - b.foreign_language
        });
        let foreignLang = null;
        let groupedPackages = [];
        let section = null;


        packages.forEach((pckg) => {
            if (pckg.foreign_language !== foreignLang) {
                foreignLang = pckg.foreign_language;
                section = {lang: null, items: []};
                section.lang = pckg.foreign_language;
                section.lang_name = getObjectById(this.props.languages, pckg.foreign_language)['name'];
                groupedPackages.push(section);
            }
            section.items.push(pckg);
        });

        groupedPackages = sortAlphabetically(groupedPackages, 'lang_name', {localeCompare: true});
        let result = groupedPackages.map((section) => {
            const sortedItems = sortAlphabetically(section.items, 'name');
            const pckgs = sortedItems.map((pckg) => (
                this.renderPackage(pckg)
            ));
            return (
                <div key={section.lang}>
                    <LanguageHeader key={section.lang} languageId={section.lang}/>
                    {pckgs}
                    <PackageAddDialog formInitialValues={{foreign_language: section.lang}} wrapper={FlatButton} wrapperProps={{label: this.props.t('package_management_new_package'),  icon: <FontIcon className="material-icons">add</FontIcon>, primary: true, style: {...this.style, width: 'auto'}}}/>
                </div>
            )
        });
        return <div>{result}</div>;

    }
}

export default translate()(PackagesList)



// WEBPACK FOOTER //
// ./src/components/packages/PackagesList.js